"use client";

import React from "react";
import { Mail, Loader } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
function NotifyForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-primary/10 border border-primary/20 rounded-lg text-center mt-4">
        <p className="text-primary font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4 mt-6">
      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Email Address</FormLabel>
            <FormControl>
              <Input type="email" placeholder="Enter your email address" className="bg-background/50" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-destructive text-sm">{submitError}</p>
        </div>}

      <Button type="submit" className="w-full" disabled={isSubmitting}>
        {isSubmitting ? <>
            <Loader className="mr-2 size-4 animate-spin" />
            Subscribing...
          </> : <>
            <Mail className="mr-2 size-4" />
            Notify Me
          </>}
      </Button>
    </Form>;
}
export default function PortfolioComingSoon() {
  return <section id="portfolio-coming-soon" className="bg-background text-foreground relative flex min-h-[70vh] items-center justify-center overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-background/85 z-10" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/golf_course_aerial_grayscale.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/golf_course_aerial_grayscale.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/golf_course_aerial_grayscale.png-wvc-sizes" alt="Cinematic Golf Course Aerial" className="h-full w-full object-cover grayscale blur-sm opacity-60" loading="lazy" />
      </div>

      {}
      <div className="relative z-20 mx-auto flex max-w-3xl flex-col items-center gap-8 px-4 text-center">
        <Badge variant="default" className="px-4 py-1.5 text-xs sm:text-sm uppercase tracking-widest shadow-lg">
          Introductory Pricing Available
        </Badge>

        <div className="space-y-4">
          <h2 className="font-default text-5xl font-semibold tracking-tight text-white sm:text-6xl md:text-7xl">
            Portfolio Coming Soon
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground sm:text-xl">
            We are currently capturing breathtaking cinematic aerials for elite
            golf courses across Arizona. Be the first to see our work and access
            exclusive launch rates.
          </p>
        </div>

        <Dialog>
          <DialogTrigger asChild>
            
          </DialogTrigger>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <DialogTitle className="font-default text-2xl">
                Join the Waitlist
              </DialogTitle>
              <DialogDescription className="text-base">
                Enter your email to be notified when our cinematic portfolio
                launches and receive details on our introductory pricing
                packages.
              </DialogDescription>
            </DialogHeader>

            <FormProvider formId="portfolio-waitlist-form" sectionName="Portfolio Coming Soon" defaultValues={{
            email: ""
          }} submitText="Notify Me" successMessage="Thank you! You've been added to our exclusive waitlist.">
              <NotifyForm />
            </FormProvider>
          </DialogContent>
        </Dialog>
      </div>
    </section>;
}